import React, { Component } from 'react';
import '../styles.css';
import { Background } from '../COMPONENTS/Background';
import * as f from '../logic';
import BackButton from '../COMPONENTS/BackButton';
import { connect } from 'react-redux';
import { setLevel, setStartLevel, setScore, setIntroduced, updateStats } from '../REDUX/actions';
import { goToPage } from '../../HOME/REDUX/actions';
import { GAME_PAGE } from '../../HOME/const';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import _ from 'lodash';

class SkillPage extends Component {
  componentDidMount() {
    this.props.setIntroduced(true);
  }

  handleSelectLevel = level => {
    if (level - 1 > this.props.levelsCompleted) {
      return;
    }

    f.initStats(this.props);

    this.props.setLevel(level);
    this.props.setStartLevel(level);
    this.props.setScore(0, 0, 0);
    this.props.goToPage(GAME_PAGE);
  };

  render() {
    return (
      <div className="page-root">
        <div className="ms-page" style={{ backgroundImage: Background }}>
          <div className="ms-selector">
            <span style={{ fontSize: '22px', margin: 'auto', marginBottom: '50px' }}>Select a start level:</span>
            {_.map([1, 2, 3, 4], l => {
              const levelInfo = f.levelInfo(l);
              const disabled = l - 1 > this.props.levelsCompleted;
              const cls = `ms-selector-item ${disabled ? '' : 'ms-selector-item-enabled'}`;
              const border = disabled ? '1px solid white' : `3px solid ${levelInfo.color}`;
              return (
                <div key={l} className={cls} style={{ border }} onClick={() => this.handleSelectLevel(l)}>
                  <div>{levelInfo.name}</div>
                  <div>{levelInfo.time / 10} seconds per task</div>
                  {l === 1 ? null : <div>{l} × points</div>}
                </div>
              );
            })}
          </div>
          <BackButton />
          <HomeButton />
        </div>
      </div>
    );
  }
}

function mapStateToProps({ ms, common }) {
  return { ...ms, ...common };
}

export default connect(
  mapStateToProps,
  { setLevel, setStartLevel, setScore, goToPage, setIntroduced, updateStats }
)(SkillPage);
